(function () {
  function init(el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 18000;
    if (isNaN(min)) min = 8;
    if (isNaN(max)) max = 20;
    if (max < min) max = min;

    var out = el.querySelector('[data-viewing-count]');
    if (!out) return;
    var current = parseInt(out.textContent, 10);
    if (isNaN(current)) current = min;

    function next() {
      var r = Math.random();
      var delta = r < 0.35 ? -1 : r < 0.7 ? 0 : 1;
      current = Math.max(min, Math.min(max, current + delta));
      out.textContent = current;

      var jitter = (Math.random() - 0.5) * 0.8 * interval;
      setTimeout(next, interval + jitter);
    }

    setTimeout(next, interval + Math.random() * interval * 0.5);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-viewing-now]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
